import { AtemApplication } from "../../modules/user/domain/constants";
import { applicationListRules, CurrentApplication } from "../../utils";
import ForgotPasswordDefault from "./ForgotPasswordDefault";
import ForgotPasswordNotPortal from "./ForgotPasswordNotPortal";
import ForgotPasswordTrading from "./ForgotPasswordTrading";

function ForgotPassword() {
  switch (CurrentApplication()) {
    case AtemApplication.CHECKLIST:
    case AtemApplication.SUPPLY_CHAIN:
    case AtemApplication.SALES_PORTAL:
    case AtemApplication.LOADING:
    case AtemApplication.SALES:
      return <ForgotPasswordNotPortal />;
    case applicationListRules.PORTAL_TRADING:
      return <ForgotPasswordTrading />;
    default:
      return <ForgotPasswordDefault />;
  }
}

export default ForgotPassword;
